import type { FunctionComponent, MutableRefObject } from "react";
import { Button, CopyContent } from "@kanda-libs/ks-design-library";
import { ModalContainer, ModalLayoutCenter } from "@kanda-libs/ks-component-ts";
import { MODAL_ID } from "components/job/JobLayout/JobActions/CheckoutUrl/constants";
import {
  COPIED_BUTTON_PROPS,
  COPY_BUTTON_PROPS,
} from "components/job/JobLayout/JobActions/CheckoutUrl/CheckoutUrlModal/constants";

export interface CheckoutUrlModalProps {
  url: string;
}

const CheckoutUrlModal: FunctionComponent<CheckoutUrlModalProps> = ({
  url,
}) => {
  return (
    <ModalContainer id={MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <>
          <ModalLayoutCenter
            id="staff-checkout-url"
            onClose={handleClose}
            ref={ref as MutableRefObject<HTMLDivElement>}
            className="w-10/12 md:w-160"
          >
            <div className="flex flex-col">
              <span className="mb-6 text-16-20-em">Checkout URL</span>
              <div className="flex flex-row">
                <div className="p-2 rounded-lg bg-neutral-200">
                  <span className="break-all text-14-22">{url}</span>
                </div>
                <div className="my-auto ml-2 min-w-20">
                  <CopyContent
                    content={url}
                    clickedView={
                      <Button.Link {...COPIED_BUTTON_PROPS} size={14} />
                    }
                  >
                    <Button.Link {...COPY_BUTTON_PROPS} size={14} />
                  </CopyContent>
                </div>
              </div>
            </div>
          </ModalLayoutCenter>
        </>
      )}
    </ModalContainer>
  );
};

export default CheckoutUrlModal;
